import React, { ReactElement } from 'react';

import classNames from 'classnames';

import styles from './ListRow.pcss';

export interface GenericListRowProps<El extends HTMLElement> extends React.HTMLAttributes<El>, React.RefAttributes<El> {
  readonly prefixIcon?: ReactElement
  readonly suffixIcon?: ReactElement
  readonly children: React.ReactElement | React.ReactElement[]
  // eslint-disable-next-line i18next/no-literal-string
  readonly 'data-stable-name'?: string
}
export interface ListRowProps extends GenericListRowProps<HTMLButtonElement> {
  disabled?: boolean
}

export const ListRow: React.FC<ListRowProps> = React.forwardRef((
  props: ListRowProps,
  ref: React.Ref<HTMLButtonElement>,
) => {
  const {
    // eslint-disable-next-line i18next/no-literal-string
    'data-stable-name': dataStableName,
    className,
    children,
    prefixIcon,
    suffixIcon,
    ...other
  } = props;
  return (
    <button
      type="button"
      disabled={props.disabled}
      ref={ref}
      {...other}
      className={classNames(styles.listRow, styles.listRowButton, className)}
      data-stable-name={dataStableName}
    >
      {prefixIcon !== undefined ? prefixIcon : <span />}
      <span className={styles.rowContent}>{children}</span>
      {suffixIcon !== undefined ? suffixIcon : <span />}
    </button>
  );
});
